<template>
  <div id="item-template">
    <div
      :name="item.name"
      :class="'map-item ' + (selected ? 'selected' : '')"
      @click="select"
    >
      <div class="list-icon">
        <i class="material-icons">settings_remote</i>
      </div>
      <div class="list-content">
        <div class="row">
          <div class="col-12">
            <div class="flex-row">
              <div class="list-header-left">
                <h2>{{ item.name }}</h2>
              </div>
              <div class="list-header-right">
                <div class="visibility-button" @click="hideClicked">
                  <i class="material-icons off" v-if="!item.isHidden">visibility_off</i>
                  <i class="material-icons on" v-if="item.isHidden">visibility_off</i>
                </div>
                <div class="status">
                  <div class="badge badge-success" v-if="item.isOnline">online</div>
                  <div class="badge badge-grey" v-if="!item.isOnline">offline</div>
                </div>
              </div>
            </div>
            <div class="list-place">
              <translate>Last update:</translate>
              {{ lastUpdateHumanized }}
            </div>
          </div>
        </div>
      </div>
      <div class="list-right">
        <router-link :to="{ name: 'Tracker', params: { trackerId: item.id } }">
          <div>
            <i class="material-icons">keyboard_arrow_right</i>
            <div class="detail-label">detail</div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['item', 'selected'],
  computed: {
    name() {
      return this.item.name
    },
    lastUpdateHumanized() {
      if (moment(this.item.lastUpdate).isValid())
        return moment(this.item.lastUpdate)
          .fromNow()
          .toString()
      return this.item.lastUpdate
    },
    latestLocationLayer() {
      return this.item.latestLocationLayer
    }
  },
  methods: {
    async select() {
      this.$emit('selected', this.item)
    },
    hideClicked() {
      this.item.isHidden = !this.item.isHidden
    }
  }
}
</script>
